(function() {
  'use strict';

  // i18n() is a no-op marker so the extraction script can find these keys.
  function i18n(key) { return key; }

  var types = [
    {
      label: i18n('Hierarchical tree'),
      name: 'tree'
    },
    {
      label: i18n('Discrete'),
      name: 'discrete'
    },
    {
      label: i18n('Discrete (multiple)'),
      name: 'discrete_multiple'
    },
    {
      label: i18n('Likert'),
      name: 'likert'
    },
    {
      label: i18n('Free text (short)'),
      name: 'string'
    },
    {
      label: i18n('Free text (long)'),
      name: 'text'
    },
    {
      label: i18n('Date'),
      name: 'date'
    },
    {
      label: i18n('DateTime'),
      name: 'datetime'
    },
    {
      label: i18n('Numeric'),
      name: 'numeric'
    },
    {
      label: i18n('Boolean'),
      name: 'boolean'
    },
    {
      label: i18n('File'),
      name: 'file'
    }
  ];

  var treeOptions = {
    limit: 1,
    allowSearch: true,
    allowSelect: true,
    inline: false,
    canEdit: false,
    buttons: {
      select: '<i class="icon-check"></i>',
      deselect: '<i class="icon-minus"></i>',
      goToSubitems: '<i class="icon-right-open-big"></i>',
      addSubitems: '<i class="icon-plus"></i>',
      addNode: '<i class="icon-plus"></i>',
      remove: '<i class="icon-trash"></i>',
      done: 'Done',
      showSelected: 'Show selected',
      hideSelected: 'Hide selected',
      backToList: 'Back to list',
      move: '<i class="icon-move"></i>',
      modalSelect: 'Select'
    }
  };

  angular.module('component.blueprints')
    .constant('BLUEPRINT_TYPES', types)
    .constant('TREE_OPTIONS', treeOptions);
})();
